import { $ } from 'src/shared/js/utils/dom';
import { merge } from 'src/shared/js/utils/helper';
import Swiper, {
  Navigation,
  Pagination,
  EffectCoverflow,
  FreeMode,
} from 'swiper';
export default class Swiperslider {
  constructor(target, params) {
    this.target = target;
    this.swiper = null;
    this.container = params.container;
    this.sliderOptions = params.sliderOptions || {};
    this.onReady = params.onReady;
  }

  init = () => {
    return new Promise(resolve => {
      this.createSlider();
      return resolve();
    });
  };

  createSlider = () => {
    // configure Swiper to use modules
    Swiper.use([Navigation, Pagination, EffectCoverflow, FreeMode]);

    const swiperDefaultConfig = {
      navigation: {
        nextEl: $('.swiper-button--next', this.container),
        prevEl: $('.swiper-button--previous', this.container),
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: 'true',
      },
      spaceBetween: 25,
      breakpoints: {
        768: {
          spaceBetween: 50,
        },
        1200: {
          spaceBetween: 100,
        },
      },
      effect: 'coverflow',
      coverflowEffect: {
        rotate: 30,
        depth: 100,
        slideShadows: false,
      },
      grabCursor: true,
      mousewheel: false,
      centeredSlides: true,
      initialSlide: 1,
      slidesPerView: 'auto',
      speed: 400,
      on: {
        init: swiper => {
          this.onReady && this.onReady(swiper);
        },
      },
    };

    const sliderConfig = merge(swiperDefaultConfig, this.sliderOptions);

    this.swiper = new Swiper(this.target, sliderConfig);
  };
}
